import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44743004"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-panel" }
const _hoisted_2 = { class: "button-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-new" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_4 = { class: "button-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-history" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "session-list"
}
const _hoisted_7 = { class: "message-panel" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "message-container" }
const _hoisted_10 = {
  class: "message-list",
  id: "current-messages"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, " 内容由AI生成，仅供参考，请遵守相关法律法规。我们将收集对话记录及用户评价用于ZWCAD助手优化。 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-content" }, "content", -1))
const _hoisted_13 = [
  _hoisted_12
]

import { onMounted,onBeforeUnmount , ref,reactive,nextTick,computed } from 'vue'
import { ChatMessage, ChatSession, RequestBody } from '@/typings'
import { queryChatSession,queryChatConversation, queryChatMessage,loadChatByJson,createNewConversation,updateConversation,deleteConversation,pinConversation} from '@/api/chat-session'
import SessionItem from '@/views/components/SessionItem.vue'
import {CaretLeft, CaretBottom } from '@element-plus/icons-vue'
import MessageRow from '@/views/components/MessageRow.vue'
import MessageInput from '@/views/components/MessageInput.vue'
import { fetchEventSource } from '@microsoft/fetch-event-source';
import useClipboard from 'vue-clipboard3';

import { useStore } from 'vuex';
import {ErrorCode, errorHandler} from '@/utils/errorHandler';
import { ErrorMessageException } from '@/utils/errorMessageException';
import { ElNotification } from 'element-plus';
import {sendNewTokenToWorker} from '@/tokenWorker';
//是否允许发送新消息，默认允许
interface Params {
  prompt: string;
  conversationGuid: string;
  parentGuid: string;
  isKnowledgeQuery?: boolean; // 可选属性
  isArchiKnowledgeQuery?: boolean; // 可选属性
}




export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  emits: ["postToCAD"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const token = computed(() => store.state.token);



// import { authState } from '@/oidcServe/auth-service';
//import emitter from '@/utils/eventBus';  
const senMessageEnable = ref(true);
//是否显示命令建议，默认不显示，当有新消息发送时允许显示
const showSuggestion = ref(false);
//是否进行知识库查询
const setKnowledgeQuery = ref(true);
//是否展开历史记录列表，默认不展开
const showHistory = ref(false)
//是否展开对话列表，默认展开
const bShowSessionPanel = ref(true);
//当前激活的会话
const activeSession = ref({} as ChatSession)
//会话列表
const sessionList = ref([] as ChatSession[])
//当前会话的内容
const activeMessages = reactive([] as ChatMessage[])
//输入框
const MessageInputRef = ref({} as any);
//右键菜单
const contextmenu = ref({} as any);
//剪切板
const { toClipboard } = useClipboard();
const needCopy = ref(false);
const needCut = ref(false);
//当前选中区域的起始和中止位置
const selectionStart = ref(0);
const selectionEnd = ref(0);
//保存剪切板中的位置
const clipboardText = ref("");
const testText = ref("测试");

//let user_token: string | null = null;
//let user_token_expires_in: number = 0;

const copyText = async (text:any) => {
	try {
	    await toClipboard(text);
      clipboardText.value = text;
	    //message.success('复制成功');
	} catch (e) {
	    console.error(e);
	}
}
//根据固定以及更新时间排序
const sortSessions = () => {
  sessionList.value.sort((a, b) => {
    if (a.pin === b.pin) {
      return new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime();
    }
    return (b.pin === 1 ? 1 : 0) - (a.pin === 1 ? 1 : 0);
  });
}


const fetchToken = async () => {
  // try {
  //   const user = await authService.getUser();
  //   if(user.access_token)
  //   {
  //     token.value = user.access_token;
  //     token.value_expires_in = user.expires_in;
  //   }
  // } catch (error) {
  //   console.error('Error fetching token:', error);
  // }
};
const handleLogout = async () => {
      // try {
      //   await authService.logout();
        // let postInfo:CADFunction = {
        // type:"login",
        // content: ""
        // }
        // let postString = JSON.stringify(postInfo);
        // emit('postToCAD', postString);
      //   console.log('User logged out');
      // } catch (error) {
      //   console.error('Error logging out:', error);
      // }
 }

//用于处理web worker消息
const handleWorkerMessage = async (event) =>{
  const data = event.detail;
      console.log('HomeView received message from worker:', data);
      
      if (data.action === 'refreshToken') {
        await refreshToken();
      }
}
const refreshToken = async () =>{
  // try {
  //       const isLoggedIn = await authService.isLoggined();
  //       if (isLoggedIn) {
  //         const user = await authService.getUser();
  //         const newToken = user.access_token;
  //         token.value = newToken;
  //         token.value_expires_in = user.expires_in;
  //         sendNewTokenToWorker(token.value, token.value_expires_in);
  //       }  
  //       else {
  //         await authService.logout();
  //       }
  //     } catch (error) {
  //       console.error('Error refreshing token:', error);
  //     }
    
}
const emit = __emit
//show-error-toast事件处理函数
const showErrorToast = (message) => {

    };
//卸载前调用
onBeforeUnmount(async () => {
      ////移除事件总线事件监听
      //emitter.off('show-error-toast', showErrorToast);
      //取消监听worker
      document.removeEventListener('worker-message', handleWorkerMessage);
});
//网页刚加载完毕的时候调用
onMounted( async () => {
  ////加载事件总线事件监听
  //emitter.on('show-error-toast', showErrorToast);
  //监听worker消息
  document.addEventListener('worker-message', handleWorkerMessage);
  await fetchToken();
  // if(token.value)
  // {
  //   //sendNewTokenToWorker(token.value, token.value_expires_in);

  //   // 查询自己的聊天会话.
  //   queryChatSession({ pageSize:1000, pageNO:1, provider: "openai" }, token.value).then((res) => 
  //   {
  //     if(undefined == res)
  //     {
  //         return;
  //     }
  //     // 讲会话添加到列表中
  //     sessionList.value.push(...res.data.conversations)
  //     // 默认选中的聊天会话是第一个
  //     if (sessionList.value.length > 0) 
  //     {
  //       activeSession.value = sessionList.value[0]
  //       queryChatConversation(activeSession.value.guid, token.value).then((res) => 
  //       {
  //         const newMessages = loadChatByJson(res.data);
  //         activeMessages.splice(0, activeMessages.length, ...newMessages);
  //       })
  //       sortSessions();
  //     }
  //   })
  // }

  // scrollToBottom("current-messages");

  if (token.value) {
  // sendNewTokenToWorker(token.value, token.value_expires_in);

    // 查询自己的聊天会话
    queryChatSession({ pageSize: 1000, pageNO: 1, provider: "openai" }, token.value)
      .then((res) => {
        if (res === undefined) {
          return;
        }
        // 将会话添加到列表中
        sessionList.value.push(...res.data.conversations);

        // 默认选中的聊天会话是第一个
        if (sessionList.value.length > 0) {
          activeSession.value = sessionList.value[0];
          queryChatConversation(activeSession.value.guid, token.value)
            .then((res) => {
              const newMessages = loadChatByJson(res.data);
              activeMessages.splice(0, activeMessages.length, ...newMessages);

              // 确保 DOM 更新完毕后再滚动到底部
              nextTick(() => {
                scrollToBottom("current-messages");
              });
            });
          sortSessions();
        }
      });
    }
})

const changeHistory = () =>{
    showHistory.value = !showHistory.value;
    sortSessions();
}
//控制左侧对话列表显示
const showHideSessionPanel = () =>{
    bShowSessionPanel.value = !bShowSessionPanel.value;
    
}
//跳转到页面底端
const scrollToBottom = (id:string) => {
    nextTick(() => {
      const messageListElement = document.getElementById(id);
      if (messageListElement) {
        messageListElement.scrollTop = messageListElement.scrollHeight;
      }
    })
}

const enterBlur = (event:Event) => {
    if(event.target)
    {
        (event.target as HTMLInputElement).blur();    
    }
}
// 固定记录
const handleSessionPin = (session: ChatSession) => {
  
  pinConversation(session.guid, !session.pin , token.value).then((res) => 
  {
    if(undefined == res)
    {
        return;
    }
    session.pin = res.data.pin;
    sortSessions();
  })

}
// 切换会话
const handleSessionSwitch = (session: ChatSession) => {
  if (!session) {
    session = createNewChatSession();
  }
  showSuggestion.value = false;
  activeSession.value = session
  // if(activeSession.value.guid)
  // {
  //   queryChatConversation(activeSession.value.guid, token.value).then((res) => {
  //   if(undefined == res)
  //   {
  //       activeMessages.splice(0, activeMessages.length);
  //       return;
  //   }
  //   const newMessages = loadChatByJson(res.data);
  //   activeMessages.splice(0, activeMessages.length, ...newMessages);
  // })
  // }
  // else{
  //       activeMessages.splice(0, activeMessages.length);
  //       return;
  // }

  // scrollToBottom("current-messages");
    if (activeSession.value.guid) {
    queryChatConversation(activeSession.value.guid, token.value)
      .then((res) => {
        if (res === undefined) {
          activeMessages.splice(0, activeMessages.length);
        } else {
          const newMessages = loadChatByJson(res.data);
          activeMessages.splice(0, activeMessages.length, ...newMessages);
        }

        // 确保 DOM 已更新完毕后再滚动
        nextTick(() => {
          scrollToBottom("current-messages");
        });
      })
      .catch(error => {
        console.error('Failed to load chat conversation:', error);
        // 处理错误，例如提示用户或记录日志
      });
  } else {
    activeMessages.splice(0, activeMessages.length);
    scrollToBottom("current-messages"); // 如果没有 GUID，也确保能滚动到最底部
  }
}

const handleSessionSwitchAsync = async (session: ChatSession | null): Promise<void> => {
  if (!session) {
    session = createNewChatSession();
  }
  showSuggestion.value = false;
  activeSession.value = session;

  try {
    const res = await queryChatConversation(activeSession.value.guid, token.value);
    if (res === undefined) {
      activeMessages.splice(0, activeMessages.length);
      return;
    }
    const newMessages = loadChatByJson(res.data);
    activeMessages.splice(0, activeMessages.length, ...newMessages);
  } catch (error) {
    console.error("Error querying chat conversation:", error);
  }

  scrollToBottom("current-messages");
};

// 从会话列表中删除会话
const handleDeleteSession = (session: ChatSession) => {
    deleteConversation(session.guid, token.value).then((res) => {
    if(undefined != res && 200 == res.status)
    {
        const index = sessionList.value.findIndex((value) => {
            return value.guid === session.guid
        });
        sessionList.value.splice(index, 1);
        if(session.guid === activeSession.value.guid)
        {
            handleSessionSwitch(sessionList.value[0]);
        }
        else if(0 == sessionList.value.length)
        {
            handleCreateSession()
        }
        // if(0 == sessionList.value.length)
        // {
        //     //handleCreateSession()
        // }
        // else if(session.guid === activeSession.value.guid)
        // {
        //     handleSessionSwitch(sessionList.value[0]);
        // }
    }
  })
}
//新增空会话数据
const createNewChatSession = (): ChatSession => {
  return {
    createTime: new Date().toISOString(),
    guid: "",
    provider: 'openai',
    status: 'normal',
    title: '',
    updateTime: new Date().toISOString(),
    pin: 0
  };
};

// 新增会话
const handleCreateSession = async () => {
    createNewConversation("NewChat","openai", token.value).then((res) => 
  {
    showHistory.value = false;
    sortSessions();
    if(undefined == res)
    {
        return;
    }
    // 讲会话添加到列表中
    const newConversation:ChatSession = {
        createTime:res.data.createTime,
        guid:res.data.guid,
        provider:res.data.provider,
        status:res.data.status,
        title:res.data.title,
        updateTime:res.data.updateTime,
        pin:0
    }
    sessionList.value.unshift(newConversation)
    handleSessionSwitch(newConversation);
    // 默认选中的聊天会话是第一个
  //   if (sessionList.value.length > 0) 
  //   {
  //     activeSession.value = sessionList.value[0]
  //     queryChatConversation(activeSession.value.guid).then((res) => 
  //     {
  //       activeMessages.value = loadChatByJson(res.data);
  //     })
  //   }
  })
}
const handleCreateSessionAsync = async (): Promise<void> => {
  try {
    const res = await createNewConversation("NewChat", "openai", token.value);
    showHistory.value = false;
    sortSessions();
    if (res === undefined) {
      return;
    }
    const newConversation: ChatSession = {
      createTime: res.data.createTime,
      guid: res.data.guid,
      provider: res.data.provider,
      status: res.data.status,
      title: res.data.title,
      updateTime: res.data.updateTime,
      pin: 0
    };

    sessionList.value.unshift(newConversation);
    await handleSessionSwitchAsync(newConversation);
  } catch (error) {
    console.error("Error creating session:", error);
  }
};


const handleUpdateSession = async(session: ChatSession) => {
    if(undefined != session.title)
    {
      if(needCopy.value)
      {
        try{
          //当可以访问 https 时，直接从剪切板中取值
          await navigator.clipboard.readText()
          .then((text) => {
            var srcStr:string = session.title;
            session.title = setChartAt(srcStr, text,selectionStart.value,selectionEnd.value),
            needCopy.value = false;
          })
        }
        catch(e){
          //当无法访问 https 时，采用本地保存的剪切板值 clipboardText，在页面外复制的值无法在页面内粘贴
          var srcStr:string = session.title;
          session.title = setChartAt(srcStr, clipboardText.value,selectionStart.value,selectionEnd.value),
          needCopy.value = false;
        }
      }
      else if(needCut.value)
      {
        var srcStr:string = session.title;
        session.title = setChartAt(srcStr, '',selectionStart.value,selectionEnd.value),
        needCut.value = false;
      }
      session.title = session.title.trim();
      updateConversation(session.title,session.guid, token.value);
    }
}

//中止当前对话，后端未实现
const handleAbortMessage = () => {
    activeMessages.pop();
    senMessageEnable.value = true;
}


const handleExcuteSuggestion = (command:string) =>{
  let postInfo:CADFunction = {
        type:"command",
        content: command
  }
  let postString = JSON.stringify(postInfo);
  emit('postToCAD', postString);
}

const handleSwitchQueryMode = (queryKnowledge:boolean) =>
{
  setKnowledgeQuery.value = queryKnowledge;
}

//处理单条消息发送和接受
const handleSendMessage = (message: string) => {
    const chatMessage = ref({} as ChatMessage);
    const responseMessage = ref({} as ChatMessage)

    var parentGuid:string = '';
    for(var i = activeMessages.length - 1; i >= 0; --i)
    {
        if(activeMessages[i].role == 'assistant' && activeMessages[i].guid.length > 0)
        {
            parentGuid = activeMessages[i].guid;
            break;
        }
    }

    chatMessage.value.role = 'user';
    chatMessage.value.content = message;
    chatMessage.value.createTime = '';
    chatMessage.value.guid = '';
    responseMessage.value.references = [];
    responseMessage.value.command = {name:"",description:""};

    activeMessages.push(chatMessage.value);

    responseMessage.value.role = 'assistant';
    responseMessage.value.content = '';
    responseMessage.value.createTime = '';
    responseMessage.value.guid = '';
    responseMessage.value.references = [];
    responseMessage.value.command = {name:"",description:""};

    activeMessages.push(responseMessage.value);

    senMessageEnable.value = false;

    queryChatMessage(message, activeSession.value.guid, parentGuid, token.value).then(response => 
    {
        if(undefined == response)
        {
            return;
        }
        
        const lines = response.data.split('\n');
        var message:String = "";
        // 遍历每一行
        for (let i = 0; i < lines.length; ++i) 
        {
            const lineStr:String = lines[i];
            if(lineStr.startsWith("data:"))
            {
                const startIndex = "data:".length;
                const data = JSON.parse(lineStr.slice(startIndex)); // 将 data: {...} 转换为标准 JSON 形式

                if("questionMessage" == data.type)
                {
                    chatMessage.value.role = data.question.role;
                    chatMessage.value.createTime = data.question.createTime;
                    chatMessage.value.guid = data.question.guid;
                    chatMessage.value.content = data.question.content;
                }
                else if("answerMessage" == data.type)
                {
                    responseMessage.value.role = data.answer.role;
                    responseMessage.value.createTime = data.answer.createTime;
                    responseMessage.value.guid = data.answer.guid;
                }
                else if("answerContent" == data.type)
                {
                    message += data.content;
                }
            }
        }

        if(setKnowledgeQuery.value)
        {
          responseMessage.value.content = message.toString();
          responseMessage.value.references = [{ url:"https://www.baidu.com/",description:"百度一下，你就知道", name:"",type:""},
            { url:"https://cn.bing.com/",description:"必应搜索", name:"",type:""},];
          responseMessage.value.command = {name:"ss",description:""};
        }
        else
        {
          responseMessage.value.content = "已执行API调度!"
          let postInfo:CADFunction = {
            type:"api",
            content: message
          }
          let postString = JSON.stringify(postInfo);
          emit("postToCAD",postString);
        }

        scrollToBottom("current-messages");
        senMessageEnable.value = true;
        showSuggestion.value = true;
    })
    scrollToBottom("current-messages");
}


const handleSendMessageFromStream = async (message: string) =>{

  if(token.value === null || token.value.trim() === '')
  {
    errorHandler(ErrorCode.NotLoggedIn, "");
    return;
  }
  // //先判断当前会话是否存在guid
  if (!activeSession.value || !activeSession.value.guid) {
    await handleCreateSessionAsync();
  }
  if (!activeSession.value || !activeSession.value.guid) {
    return;
  }


  const chatMessage = reactive({} as ChatMessage);
  const responseMessage = reactive({} as ChatMessage)
  
  let parentGuid:string = '';
  for(var i = activeMessages.length - 1; i >= 0; --i)
  {
      if(activeMessages[i].role == 'assistant' && activeMessages[i].guid.length > 0)
      {
          parentGuid = activeMessages[i].guid;
          break;
      }
  }

  chatMessage.role = 'user';
  chatMessage.content = message;
  chatMessage.createTime = '';
  chatMessage.guid = '';
  chatMessage.command = {name:"",description:""};

  activeMessages.push(chatMessage);

  responseMessage.role = 'assistant';
  responseMessage.content = '';
  responseMessage.createTime = '';
  responseMessage.guid = '';
  responseMessage.references = [];
  responseMessage.command = {name:"",description:""};

  activeMessages.push(responseMessage);
  let index = activeMessages.length - 1;
  const ctrl = new AbortController()
  const params: Params = {
  prompt: message,
  conversationGuid: activeSession.value.guid,
  parentGuid: parentGuid
  };
  if (setKnowledgeQuery.value) {
    params.isKnowledgeQuery = true;
  } else {
    params.isKnowledgeQuery = false;
  }
  params.isArchiKnowledgeQuery=false;


  senMessageEnable.value = false;

  
  const url="https://testassistant.zwsoft.cn/zwai/chat/openai";
  let isErrorOccurred = false; // 标志是否有错误发生
  let messageError = null; // 保存 onmessage 中的异常
  try
  {
    await fetchEventSource(url, 
    {
      method: 'post',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.value}`,
          "Accept": "text/event-stream",
          'Connection': 'keep-alive'
      },
      signal: ctrl.signal,
      body: JSON.stringify(params),
      openWhenHidden: true,
      async onopen (response: Response) {
        
        if (response.ok && response.status === 200) {
          scrollToBottom("current-messages");
          //console.log('连接成功打开。');
        } else {
          errorHandler(response.status, response.statusText);
        }
      },
      async onmessage(msg) 
      {
        //接收一次数据段时回调，因为是流式返回，所以这个回调会被调用多次
        if(msg.event==''){
          //进行连接正常的操作
          try{
            
            //console.log("onmessage : " + msg.data)
            const dataObj = JSON.parse(msg.data)

            // 判断是否为错误消息格式
            if (dataObj.code && dataObj.message) {
              isErrorOccurred = true;
              messageError = new ErrorMessageException(dataObj.code, dataObj.message);
              return;
            }

            if(setKnowledgeQuery.value)
            {
              if (dataObj.references != null) {
                responseMessage.references = dataObj.references;
                responseMessage.command = dataObj.command;
              } else if (dataObj.answer != null) {
                responseMessage.guid = dataObj.answer.guid;
              } else if (dataObj.question != null) {
                chatMessage.guid = dataObj.question.guid;
              }
              else if(dataObj.streamContent != null)
              {
                responseMessage.content+=dataObj.streamContent;
              }
            }
            else
            {
              if (dataObj.command != null) {
                responseMessage.command = dataObj.command;
              } else if (dataObj.answer != null) {
                responseMessage.guid = dataObj.answer.guid;
              } else if (dataObj.question != null) {
                chatMessage.guid = dataObj.question.guid;
              }
              else if(dataObj.streamContent != null)
              {
                responseMessage.content+=dataObj.streamContent;
              }
            }
            scrollToBottom("current-messages");
          }
          catch (e)
          {
            console.log("prese problem");
            isErrorOccurred = true;
            messageError = e;
          }
        }
        else if (msg.event === 'close') 
        {
          //连接错误的操作
          console.log('close error');
        }
      },
      onclose() 
      {
        if(isErrorOccurred)
        {
          if (messageError instanceof ErrorMessageException) {
            errorHandler(messageError.errorCode, messageError.errorMessage);
          } else {
            errorHandler(ErrorCode.BadRequest, messageError.message);
          }
          senMessageEnable.value = true; 
          return;
        }
        //正常结束的回调
        senMessageEnable.value = true;
        if(setKnowledgeQuery.value)
        {
          showSuggestion.value = true;
        }
        else
        {
          let postInfo:CADFunction = {
            type:"api",
            content: responseMessage.command
          }
          let postString = JSON.stringify(postInfo);
          emit("postToCAD", postString);
        }
      },
      onerror(err) 
      { 
        
         //连接出现异常回调
         // 取消请求
         throw err

      },
    });
  }catch (err){
    console.error('发送消息时出错：', err);
    if (err instanceof ErrorMessageException) {
        errorHandler(err.errorCode, err.errorMessage);
      } else {
        errorHandler(ErrorCode.BadRequest, err.message);
      }
    senMessageEnable.value = true;  // 在异常情况下恢复发送状态
  }
  scrollToBottom("current-messages");
  
}


//右键菜单复制功能
const copy = () =>
{
    var selectText = window.getSelection().toString();
    if(selectText)
    {
      copyText(selectText);
    }
}

//右键菜单粘贴功能
const paste = () =>
{
  if(!document.activeElement)
  {
    return;
  }
  if("messageInputId" == document.activeElement.id)
  {
    selectionStart.value = document.activeElement.selectionStart;
    selectionEnd.value = document.activeElement.selectionEnd;

    try{
      //当可以访问 https 时，直接从剪切板中取值
      navigator.clipboard.readText()
      .then((text) => {
        var input:string = MessageInputRef.value.messageInputRef.textarea.value;
        MessageInputRef.value.messageInputRef.textarea.value = setChartAt(input, text,selectionStart.value,selectionEnd.value),
        MessageInputRef.value.messageInputRef.focus();
        //MessageInputRef.value.messageInputRef.setSelectionRange(selectionStart.value,selectionStart.value);
        MessageInputRef.value.messageInputRef.textarea.dispatchEvent(new Event('input'));
      })
    }
    catch(e)
    {
      //当无法访问 https 时，采用本地保存的剪切板值 clipboardText，在页面外复制的值无法在页面内粘贴
      var input:string = MessageInputRef.value.messageInputRef.textarea.value;
      MessageInputRef.value.messageInputRef.textarea.value = setChartAt(input, clipboardText.value,selectionStart.value,selectionEnd.value),
      MessageInputRef.value.messageInputRef.focus();
      //MessageInputRef.value.messageInputRef.setSelectionRange(selectionStart.value,selectionStart.value);
      MessageInputRef.value.messageInputRef.textarea.dispatchEvent(new Event('input'));
    }
  }
  else if("currentTitleInputId" == document.activeElement.id)
  {
    selectionStart.value = document.activeElement.selectionStart;
    selectionEnd.value = document.activeElement.selectionEnd;
    needCopy.value = true;

    // selectionStart.value = document.activeElement.selectionStart;
    // document.activeElement.value +=  clipboardText.value;
    // document.activeElement.dispatchEvent(new Event('input'));
    //document.activeElement.focus();
  }
  else if("sessionInputId" == document.activeElement.id)   
  {
    selectionStart.value = document.activeElement.selectionStart;
    selectionEnd.value = document.activeElement.selectionEnd;
    needCopy.value = true;
  }    
}

//右键菜单剪切功能
const cut = () =>
{
  var selectText = window.getSelection().toString();
  if(!selectText || !document.activeElement)
  {
    return;
  }
  if("messageInputId" == document.activeElement.id)
  {
    selectionStart.value = document.activeElement.selectionStart;
    selectionEnd.value = document.activeElement.selectionEnd;

    var input:string = MessageInputRef.value.messageInputRef.textarea.value;
    MessageInputRef.value.messageInputRef.textarea.value = setChartAt(input, '',selectionStart.value,selectionEnd.value),
    MessageInputRef.value.messageInputRef.focus();
    MessageInputRef.value.messageInputRef.textarea.dispatchEvent(new Event('input'));
    copyText(selectText);
  }
  else if("currentTitleInputId" == document.activeElement.id)
  {
    needCut.value = true;
    selectionStart.value = document.activeElement.selectionStart;
    selectionEnd.value = document.activeElement.selectionEnd;
    copyText(selectText);
  }
  else if("sessionInputId" == document.activeElement.id)   
  {
    needCut.value = true;
    selectionStart.value = document.activeElement.selectionStart;
    selectionEnd.value = document.activeElement.selectionEnd;
    copyText(selectText);
  }
}

//判断当前是否有选中的内容
const isContextSelected = ()=>
{
  if(window.getSelection().toString())
  {
    return true;
  }
  return false;
}

//判断input控件是否聚焦
const isInputElemFocused = ()=>
{
  if(document.activeElement && ("text" == document.activeElement.type || "textarea" == document.activeElement.type))
  {
    return true;
  }
  return false;
}

//处理默认的复制事件
const onCopy = (event:ClipboardEvent)=>
{
  event.preventDefault();
  var selectText = window.getSelection().toString();
  if(selectText)
  {
    copyText(selectText);
  }
}


//替换父串中特定位置内容
const setChartAt = (src:string, subStr:string, iStart:number, iEnd:number) =>
{
  var iLastIndex:number = src.length - 1;
  iStart = iStart >= 0 ? iStart : 0;
  iStart = iStart < src.length? iStart : src.length - 1;
  if(iStart >= iLastIndex)
  {
    return src+subStr;
  }

  return src.substring(0,iStart) + subStr + src.substring(iEnd);
}



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "home-view",
    onCopy: onCopy
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          class: "new-button",
          icon: "el-icon-new",
          onClick: handleCreateSession
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("slider.new")), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          class: "history-button",
          icon: "el-icon-history",
          onClick: changeHistory
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("slider.history")) + " ", 1),
            (showHistory.value)
              ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0,
                  size: 22,
                  class: "icon-caret"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CaretBottom))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_icon, {
                  key: 1,
                  size: 22,
                  class: "icon-caret"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CaretLeft))
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      (showHistory.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sessionList.value, (session, index) => {
              return (_openBlock(), _createBlock(SessionItem, {
                key: session.guid,
                active: session.guid === activeSession.value.guid,
                session: sessionList.value[index],
                class: "session",
                onPin: ($event: any) => (handleSessionPin(session)),
                onSwitch: ($event: any) => (handleSessionSwitch(session)),
                onDelete: ($event: any) => (handleDeleteSession(session)),
                onUpdate: ($event: any) => (handleUpdateSession(session))
              }, null, 8, ["active", "session", "onPin", "onSwitch", "onDelete", "onUpdate"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, bShowSessionPanel.value]
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_input, {
          class: "current-title",
          modelValue: activeSession.value.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeSession.value.title) = $event)),
          id: "currentTitleInputId",
          rows: "1",
          resize: "none",
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (handleUpdateSession(activeSession.value))),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (enterBlur($event)), ["enter","native"]))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeMessages, (message, index) => {
            return (_openBlock(), _createBlock(MessageRow, {
              key: message.createTime + index,
              conversationGuid: activeSession.value.guid,
              message: message,
              senMessageEnable: senMessageEnable.value,
              suggestionStatus: index == activeMessages.length - 1 && showSuggestion.value,
              isLastMessage: index == activeMessages.length - 1,
              onExecuteSg: handleExcuteSuggestion
            }, null, 8, ["conversationGuid", "message", "senMessageEnable", "suggestionStatus", "isLastMessage"]))
          }), 128))
        ]),
        _hoisted_11
      ]),
      _createVNode(MessageInput, {
        ref_key: "MessageInputRef",
        ref: MessageInputRef,
        onSetMode: handleSwitchQueryMode,
        onSend: handleSendMessageFromStream,
        onAbort: handleAbortMessage,
        senMessageEnable: senMessageEnable.value
      }, null, 8, ["senMessageEnable"]),
      _createVNode(_component_el_button, {
        class: "toggle-session-panel",
        onClick: showHideSessionPanel
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: _normalizeClass(bShowSessionPanel.value ? 'el-icon-arrow-left' : 'el-icon-arrow-right')
          }, _hoisted_13, 2)
        ]),
        _: 1
      })
    ])
  ], 32)), [
    [_directive_contextmenu, void 0, "contextmenu"]
  ])
}
}

})